export function formatLink(value: string): string {
  if (!value.startsWith('http://') && !value.startsWith('https://')) {
    return `http://${value}`;
  }

  return value;
}
